import { Predicate } from "@siteimprove/alfa-predicate";
import { hasComputedStyle } from "./has-computed-style.js";
const { equals } = Predicate;
/**
 * @public
 */
export function isPositioned(device, ...positions) {
    return hasComputedStyle("position", (position) => positions.some(equals(position.value)), device);
}
//# sourceMappingURL=is-positioned.js.map